import React from 'react';
import {connect} from 'react-redux';
import Error404Page from '../Error404Page';
import ErrorPage from '../ErrorPage';
import CheckoutContent from './CheckoutContent';
import CheckoutSidebar from './CheckoutSidebar';
import TwoColumnLayout from '../TwoColumnLayout';
import TimedOut from "./TimedOut";
import {fingerprintSet} from '../../actions/creators';
import {sessionFetch, onCheckoutUnmount, nextStep, CHECKOUT_CONTEXT_TICKETS, checkoutLoaded, CHECKOUT_CONTEXT_CANDYBAR} from '../../actions/creators/checkout';
import {pointsFetch} from '../../actions/creators/user';
import {getUserInfo,getCheckoutTimedOut, getCheckoutOrderSeatsLabels, getCheckoutOrderTicketsCount, getCheckoutSession, getCheckoutTicketsWithQuantity, getCheckoutContext, getCinemaEntities, getCheckoutMovie, getCheckoutSelectedPaymentOptionBookingFee, getCheckoutCandybarOrderTotal, getCandybarItemEntities, getCheckoutOrderCandybar, getCheckoutGrandTotal, getCheckoutSelectedMethodGrandTotalString, getCheckoutNextButtonText, getCheckoutNextStep, getCheckoutSelectedTicketsString, getCheckoutTicketsTotal} from '../../reducers';
import {getMovieStartedTimeUnix} from '../../utils/showtimes';
import { AnalyticsCheckout } from '../../utils/analytics';
import BubblesAnimation from './BubblesAnimation';
import NoContentMessage from '../common/NoContentMessage';
import { CinemaType, MovieType } from '../../types/entities';
import { dialogClose, dialogOpen } from '../../actions/creators/dialogs';
import CheckoutMobileSummary from './CheckoutMobileSummary';
import { CANDYBAR_CHECKOUT_LOADED, TICKETS_CHECKOUT_LOADED } from '../../actions/types';

let lastTracked;

interface Props {
  context: string,
  onLoad: Function,
  sessionFetch: Function,
  pointsFetch: Function,
  abandon: Function,
  data: {
    id: number,
    custom_pointer: string|null,
    extra: any
  },
  match: {
    params: {
      id: string|number
    }
  },
  isLoading: boolean,
  loadError: number|string|null,
  timedOut: boolean,
  bookingFee: number,
  candybarAmount: number,
  candybarCatalog: { [key: string]: any } | { [key: number]: any },
  candybarOrder: any[],
  cinema: CinemaType,
  grandTotal: number,
  grandTotalPaymentString: string,
  movie: MovieType,
  movieStarted: boolean,
  nextButtonText: string,
  nextStep: string,
  seatsLabels: string[],
  ticketsAmount: number,
  ticketsString: string,
  ticketsSum: number,
  userId: number|null,
  userIeCode: string|null,
  dialogOpen: Function,
  dialogClose: Function,
  nextStepAction: () => void
}

class CheckoutPage extends React.Component<Props> {
  
  private cursor = React.createRef<HTMLImageElement>();

  constructor(props) {
    super(props);

    this.setPointer = this.setPointer.bind(this);
    this.unsetPointer = this.unsetPointer.bind(this);
    this.setCursorPosition = this.setCursorPosition.bind(this);
  }

  componentDidMount() {
    this.props.onLoad(this.props.context === CHECKOUT_CONTEXT_CANDYBAR ? CANDYBAR_CHECKOUT_LOADED : TICKETS_CHECKOUT_LOADED);
    this.setPointer();
    
    // @todo Add a hook on middleware
    if (this.props.context === CHECKOUT_CONTEXT_CANDYBAR) {
      this.displayAlert();
    }

    if (this.props.context === CHECKOUT_CONTEXT_TICKETS) {
      this.props.sessionFetch(this.props.match.params.id).then(() => this.props.pointsFetch(this.props.match.params.id));
    }
  }

  componentWillUnmount() {
    this.props.abandon();
    this.unsetPointer();
  }

  setPointer() {
    if (!matchMedia('(pointer:fine)').matches || !this.props.data || !this.props.data.custom_pointer) return;

    document.body.classList.add('js-cursor');
    document.addEventListener('mousemove', this.setCursorPosition);
  }

  unsetPointer() {
    document.body.classList.remove('js-cursor');
    document.removeEventListener('mousemove', this.setCursorPosition);
  }

  setCursorPosition(e) {
    const cursor = this.cursor.current;
    if (!cursor) return;

    var x = e.clientX;
    var y = e.clientY;
    cursor.style.left = x + 'px';
    cursor.style.top = y + 'px';
  }

  componentDidUpdate(prevProps) {
    if (CHECKOUT_CONTEXT_TICKETS === this.props.context) {
      if (this.props.match.params.id !== prevProps.match.params.id) {
        this.props.sessionFetch(this.props.match.params.id).then(() => this.props.pointsFetch(this.props.match.params.id));
      }

      if (this.props.userId !== prevProps.userId || this.props.userIeCode !== prevProps.userIeCode) {
        this.props.pointsFetch(this.props.match.params.id);
      }

      if (this.props.data && this.props.movie && this.props.cinema && this.props.data.id !== lastTracked) {
        lastTracked = this.props.data.id;
        AnalyticsCheckout.trackStep('tickets', {session: this.props.data, movie: this.props.movie, cinema: this.props.cinema});
      }
    
      this.setPointer();
    }

    if (CHECKOUT_CONTEXT_CANDYBAR === this.props.context) {
      if (this.props.cinema && (!prevProps.cinema || this.props.cinema.id !== prevProps.cinema.id)) {
        this.displayAlert();
      }
    }
  }

  // @todo Move to a middleware
  displayAlert() {
    if (!this.props.cinema) return;

    if (this.props.cinema.candybar) {
      this.displayCinemaAlert();
    } else {
      this.displayNoCandybarAlert();
    }
  }

  displayCinemaAlert() {
    const { dialogClose } = this.props;
    const message = `¡Atención! Estás por comprar alimentos para ${this.props.cinema.name}`;

    this.props.dialogOpen({
      message,
      buttons: [
        {
          label: 'Cancelar',
          onClick: (dialog) => {
            document.location.href = '/dulceria';
            dialog.id && dialogClose(dialog.id);
          }
        },
        {
          label: 'Continuar',
          primary: true,
          onClick: (dialog) => {
            dialog.id && dialogClose(dialog.id);
          }
        }
      ]
    });
  }

  displayNoCandybarAlert() {
    const { dialogClose } = this.props;
    const message = `Cine no disponible para ordenar. Lo sentimos, la compra de productos de dulcería en este cine no está disponible en este momento.`;

    this.props.dialogOpen({
      message,
      buttons: [
        {
          label: 'Volver',
          primary: true,
          onClick: (dialog) => {
            document.location.href = '/dulceria';
            dialogClose(dialog.id);
          }
        }
      ]
    });
  }

  render() {
    const { context } = this.props;

    if (!context) return null;

    if (CHECKOUT_CONTEXT_TICKETS === context) {
      if (this.props.isLoading) return null;

      if (this.props.loadError) {
        if (this.props.loadError === 404) {
          return <Error404Page/>;
        } else {
          return <ErrorPage/>;
        }
      }

      if (this.props.timedOut) {
        return <TimedOut/>;
      }

      if (!this.props.data) {
        return null;
      }

      if (this.props.movieStarted) {
        return <ErrorPage title="Horario no disponible">
          <NoContentMessage icon='fal fa-clock' bigTitle='Ups!'>
            <p>El horario que estas buscando ya no esta disponible.</p>
          </NoContentMessage>
        </ErrorPage>;
      }
    }

    return <React.Fragment>
      <TwoColumnLayout MainContent={CheckoutContent} SidebarContent={CheckoutSidebar} {...this.props}/>
      {(CHECKOUT_CONTEXT_TICKETS === context) && this.renderCustomAssets()}
      <CheckoutMobileSummary
        bookingFee={this.props.bookingFee}
        candybarAmount={this.props.candybarAmount}
        candybarCatalog={this.props.candybarCatalog}
        candybarOrder={this.props.candybarOrder}
        grandTotal={this.props.grandTotal}
        grandTotalPaymentString={this.props.grandTotalPaymentString}
        nextButtonText={this.props.nextButtonText}
        ticketsAmount={this.props.ticketsAmount}
        ticketsString={this.props.ticketsString}
        ticketsSum={this.props.ticketsSum}
        seatsLabels={this.props.seatsLabels}
        movie={this.props.movie}
        cinema={this.props.cinema}
        session={this.props.data}
        onNext={this.props.nextStepAction}
      />
    </React.Fragment>;
  }

  renderCustomAssets() {
    return <React.Fragment>
      {this.props.data.extra.bubbles_animation ? <BubblesAnimation/> : null}
      {this.props.data.custom_pointer ? <img ref={this.cursor} src={this.props.data.custom_pointer} style={{position:'fixed',pointerEvents:'none',zIndex:999999}}/> : null}
    </React.Fragment>;
  }
}

const mapStateToProps = (state, props) => {
  const { context } = props;
  const userInfo = getUserInfo(state);
  const data = getCheckoutSession(state);
  const cinemas = getCinemaEntities(state);
  let cinema;
  
  if (CHECKOUT_CONTEXT_TICKETS === context) {
    cinema = data ? cinemas[data.cinema_id] : null;
  } else {
    const cinemaId = document.location.pathname.match(/cine-(\d+)/);
    cinema = cinemaId ? cinemas[parseInt(cinemaId[1], 10)] : null;
  }

  return {
    bookingFee: getCheckoutSelectedPaymentOptionBookingFee(state),
    candybarAmount: getCheckoutCandybarOrderTotal(state),
    candybarCatalog: getCandybarItemEntities(state),
    candybarOrder: getCheckoutOrderCandybar(state),
    cinema,
    data,
    movie: getCheckoutMovie(state),
    movieStarted: data && (getMovieStartedTimeUnix() > data.date),
    grandTotal: getCheckoutGrandTotal(state),
    grandTotalPaymentString: getCheckoutSelectedMethodGrandTotalString(state),
    isLoading: state.checkoutData.isLoading,
    loadError: state.checkoutData.loadError,
    nextButtonText: getCheckoutNextButtonText(state),
    nextStep: getCheckoutNextStep(state),
    tickets: getCheckoutTicketsWithQuantity(state),
    ticketsString: getCheckoutSelectedTicketsString(state),
    ticketsSum: getCheckoutOrderTicketsCount(state),
    ticketsAmount: getCheckoutTicketsTotal(state),
    seatsLabels: getCheckoutOrderSeatsLabels(state),
    timedOut: getCheckoutTimedOut(state),
    userId: userInfo && userInfo.id,
    userIeCode: userInfo && userInfo.iecode,
  };
};

const mapDispatchToProps = dispatch => ({
  dialogOpen: dialog => dispatch(dialogOpen(dialog)),
  dialogClose: dialogId => dispatch(dialogClose(dialogId)),
  onLoad: type => dispatch(checkoutLoaded(type)),
  sessionFetch: sessionId => dispatch(sessionFetch(sessionId)),
  pointsFetch: sessionId => dispatch(pointsFetch(sessionId)),
  abandon: () => dispatch(onCheckoutUnmount()),
  fingerprintSet: id => dispatch(fingerprintSet(id)),
  nextStepAction: () => dispatch(nextStep()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckoutPage);